import React, { ChangeEventHandler, useState } from 'react';
import { IFetchDocumentFilters, useDeleteDocument, useFetchDocuments, useUploadDocument } from '../../../hooks/admin/document/document';
import { toast } from 'react-toastify';

interface Document {
  name: string;
  type: string;
  size: string;
  modified: string;
  status: string;
}

const DocumentsPage: React.FC = () => {
const api_key="99472f4d-bf99-4804-8455-36a515979678"
const user_id="2"
const [fetchDocumentPayload, setFetchDocumentPayload]=useState<IFetchDocumentFilters>({
  user_id,
  is_approved:"",
  page:"1",
page_size:"10",
search:""

})


const uploadAPI= useUploadDocument()
 const fetchDocuments= useFetchDocuments(fetchDocumentPayload)
 const deleteDocument= useDeleteDocument()


const [documents, setDocuments] = useState<Document[]>([
    { name: 'Company Policy.pdf', type: 'PDF', size: '2.4 MB', modified: 'Jan 15, 2025', status: 'Processed' },
    { name: 'HR Guidelines.docx', type: 'Word', size: '1.8 MB', modified: 'Jan 12, 2025', status: 'Processing' },
  ]);


  const [selectedFile, setSelectedFile] = useState<File | null>(null);

const handleFileChange=(e:React.ChangeEvent<HTMLInputElement>)=>{
  if(e.currentTarget.files){

    setSelectedFile(e.currentTarget.files[0])
  }
}

const uploadFile=()=>{
  if(!selectedFile?.name){
    return 
  }
  const formData= new FormData()

  formData.append('file',selectedFile)
  formData.append('api_key', api_key)
  toast.dismiss()
  toast.loading(`Uploading file`)
  uploadAPI.mutate(formData, {
    onSuccess(uploadResponse){
console.log({uploadResponse})
toast.dismiss()
toast.success(`File Uploaded successfully`)
fetchDocuments.refetch()
    }, 
    onError(uploadError){
      toast.dismiss()
      toast.error(  `Unable to upload file`)
console.log({uploadError})
    }
  })
}


const handleDeleteDocument=(id:number)=>{

  toast.dismiss()
  toast.loading(`Deleting Document`)
deleteDocument.mutate(id, {
  onSuccess(deleteResponse){
toast.dismiss()
toast.success(`Document deleted successfully`)
fetchDocuments.refetch()

  },
  onError(deleteError){

    toast.dismiss()
    toast.error(`Unable to delete document`)
  }
})

}

  return (
    <div className="bg-gray-100 min-h-screen font-sans">
     

      <div className="container mx-auto p-6">
        {/* Document Upload Section */}
        <div className="bg-white shadow rounded p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Document Upload</h2>
            {/* <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
              Upload New
             
            </button> */}
            <label htmlFor="fileInput" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded cursor-pointer">
  Select New Upload
</label>
<input id="fileInput" type="file" className="hidden" 
onChange={(e)=>handleFileChange(e)}
 />

  {!!selectedFile?.name ?<button 
  onClick={uploadFile}
  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
              Upload File
             
            </button>: null}
          </div>
          <div className="border-dashed border-2 border-gray-400 rounded p-6 text-center">
            <p className="text-gray-600 mb-2">{selectedFile?.name ||"Drag and drop files here or click to browse"}</p>
            <p className="text-gray-500 text-sm">Supported formats: PDF, Word, PPT, CSV, Excel</p>
          </div>
        </div>

        {/* Documents Section */}
        <div className="bg-white shadow rounded p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Documents</h2>
            <div className="flex items-center space-x-4">
              <div className="relative">
                <input type="text" placeholder="Search documents..." className="border border-gray-300 rounded px-3 py-2" />
                {/* Search Icon (replace with your icon) */}
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2">🔍</div> 
              </div>
              <select className="border border-gray-300 rounded px-3 py-2">
                <option>All Types</option>
                {/* Add more options as needed */}
              </select>
            </div>
          </div>

          {/* Documents Table */}
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Modified</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody>
              {fetchDocuments.data?.documents?.map((doc, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="px-4 py-2 whitespace-nowrap">{doc.name}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{doc.doc_type}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{"doc.size"}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{"doc.modified"}</td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    <span className={doc.name === 'Processed' ? 'text-green-500' : 'text-yellow-500'}>{"doc.status"}</span>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap justify-center ">
                    {/* Action Icons (replace with your icons) */}
                    {/* <button>

                    <span>✏️</span> 
                    </button> */}
                    <button onClick={()=>handleDeleteDocument(doc.id)} disabled={deleteDocument.isLoading}>

                    <span>🗑️</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DocumentsPage;